<template>
  <div class="l-page l-page--analysis">
    <!-- サイドバーエリア -->
    <page-sidebar />
    <!-- /サイドバーエリア -->
    <main class="l-main">
      <div class="l-main-head">
        <!-- パンくずリスト -->
        <breadcrumb :breadcrumb-data="breadcrumbData" :additional-classes="['p-breadcrumb--analysis-message']" />
        <!-- /パンくずリスト -->
        <!-- <date-range-picker
                :initial-start-date="calendarStartDate"
                :initial-end-date="calendarEndDate"
                :onDateRangeChanged="onDateRangeChanged"
                ref="refCalendarModal"
                cancelButtonLabel="キャンセル"
                enterButtonLabel="決定"
            ></date-range-picker> -->
      </div>
      <div class="l-main-content">
        <div class="p-analysis-message">
          <h2 class="c-title c-title--download">
            <div class="c-title__text u-fs34">メッセージ単位</div>
            <div class="c-proposal u-w470">
              <div class="c-icon c-icon--blue-2 u-wh24">
                <svg
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                  <use xlink:href="/assets/img/sprite.svg#light" />
                </svg>
              </div>
            </div>
            <div class="c-text"><a :href="deviceCsvUrl" target="_blank">CSVデータ ダウンロード</a></div>
          </h2>
          <div
            class="p-analysis-message__data"
            :class="[{'is-loading': isLoadingDataTable}, {'is-empty': isEmptyDataTable}]"
          >
            <div class="c-loader"></div>
            <div class="c-empty">
              <div class="c-empty__text">配信後にデータが反映されます</div>
            </div>
            <div class="p-analysis-message__content p-analysis-message__content--table-static">
              <div id="table-wrapper">
                <table class="c-table c-table--static c-table--delivery-message">
                  <thead>
                    <tr>
                      <th class="c-table__cell--center u-w100 sticky">
                        <span class="c-table__text">配信日</span>
                      </th>
                      <th class="c-table__cell--center u-w100 sticky">
                        <span class="c-table__text">配信時間</span>
                      </th>
                      <th class="c-table__cell--center u-w100 sticky">
                        <span class="c-table__text">集計日</span>
                      </th>
                      <th class="c-table__cell--center sticky">
                        <span class="c-table__text">タイトル・メッセージ</span>
                      </th>
                      <th class="c-table__cell--center u-w146">
                        <span class="c-table__text">配信ターゲット</span>
                      </th>
                      <th class="c-table__cell--center u-w140">
                        <span class="c-table__text">配信対象数</span>
                      </th>
                      <th class="c-table__cell--center u-w140">
                        <span class="c-table__text">インプレッション</span>
                      </th>
                      <th class="c-table__cell--center u-w140">
                        <span class="c-table__text">クリック数</span>
                      </th>
                      <th class="c-table__cell--center u-w140">
                        <span class="c-table__text">クリック率</span>
                      </th>
                      <th class="c-table__cell--center u-w150">
                        <span class="c-table__text">設定URL</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="summaryMessageDaily">
                      <tr>
                        <td class="c-table__cell--center c-table__cell--middle sticky">{{ deliveryMonthDay }}</td>
                        <td class="c-table__cell--center c-table__cell--middle sticky">{{ deliveryTime }}</td>
                        <td class="c-table__cell--center c-table__cell--middle sticky">{{ summaryMonthDay }}</td>
                        <td class="c-table__cell--center c-table__cell--middle sticky">{{ summaryMessageDaily.message.message_title }}</td>
                        <td class="c-table__cell--center c-table__cell--middle">{{ getConditionString() }}</td>
                        <td class="c-table__cell--center c-table__cell--middle">{{ formatNumber(summaryMessageDaily.distribution_count) }}</td>
                        <td class="c-table__cell--center c-table__cell--middle">{{ parseInt(summaryMessageDaily.display_count).toLocaleString() }}</td>
                        <td class="c-table__cell--center c-table__cell--middle">{{ parseInt(summaryMessageDaily.click_count).toLocaleString() }}</td>
                        <td class="c-table__cell--center c-table__cell--middle">{{ ctr }}</td>
                        <td class="c-table__cell--center c-table__cell--middle c-table__cell--external-link">
                          <a :href="message.click_url" target="_blank">
                            サイトへリンク
                            <div class="c-icon c-icon--blue-link-1 u-wh16" style="margin: 5px auto;">
                              <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <use xlink:href="/assets/img/sprite.svg#external-link" />
                              </svg>
                            </div>
                          </a>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>

            <div v-if="summaryMessageDaily" class="p-analysis-message-segment">
              <div class="p-message-edit-confirm-list fit-width">
                <div class="p-message-edit-confirm-list__item">
                  <div class="p-message-edit-confirm__title">配信条件</div>
                  <div class="p-message-edit-confirm__text">{{ getConditionString() }}</div>
                </div>
                <template v-if="hasMessageCondition()">
                  <div v-for="(messageCondition, loopIndex1) in message.message_conditions" :key="loopIndex1" class="p-message-edit-confirm-list__item">
                    <div class="p-message-edit-confirm__title">セグメント条件</div>
                    <ul class="p-message-edit-confirm-segment-list">
                      <li class="p-message-edit-confirm-segment-list__item">選択：{{ getConditionJoinTypeString(messageCondition.condition) }} 条件</li>
                      <li class="p-message-edit-confirm-segment-list__item">
                        {{ getConditionTypeString(messageCondition.condition) }}</li>
                      <li v-for="(conditionDetail, loopIndex2) in getConditionDetails(messageCondition.condition)" :key="loopIndex2" class="p-message-edit-confirm-segment-list__item">
                        {{ conditionInfo.conditionOperatorTypes[conditionDetail.condition_operation] }} / {{ getDescription(conditionDetail) }}
                      </li>
                    </ul>
                  </div>
                </template>
                <div v-if="hasTopicMessageCondition()" class="p-message-edit-confirm-list__item">
                  <div class="p-message-edit-confirm__title">属性条件</div>
                  <ul class="p-message-edit-confirm-segment-list">
                    <li v-for="(topicConditionDetail, loopIndex3) in getTopicConditionDetails()" :key="loopIndex3" class="p-message-edit-confirm-segment-list__item">
                      {{ getTopicConditionDetailTypeString(topicConditionDetail) }} : {{ getTopicConditionDetailValueString(topicConditionDetail) }}
                    </li>
                  </ul>
                </div>
                <template v-if="hasMessageCustomCondition()">
                  <div class="p-message-edit-confirm-list__item">
                    <div class="p-message-edit-confirm__title">カスタム条件</div>
                    <ul class="p-message-edit-confirm-segment-list">
                      <li v-for="(messageCustomCondition, loopIndex4) in message.message_custom_conditions" :key="loopIndex4" class="p-message-edit-confirm-segment-list__item">
                        {{ getMessageCustomConditionString(messageCustomCondition) }}
                      </li>
                    </ul>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <h3 class="c-title">
            <div class="c-title__text u-fs-w22">デバイス・OSの傾向</div>
          </h3>
          <analysis-tab
            classes="c-tab--analysis c-tab--device c-tab--os"
            :current="tab.current"
            :on-select="onTabClick"
          />
          <div
            class="p-analysis-message__graph"
            :class="[{'is-loading': isLoadingPiChartDevice || isLoadingPiChartOs}, {'is-empty': isEmptyPiChartDevice || isEmptyPiChartOs}]"
          >
            <div class="c-loader"></div>
            <div class="c-empty">
              <div class="c-empty__text">配信後にデータが反映されます</div>
            </div>
            <div class="p-analysis-message__content p-analysis-message__content--device">
              <h4 class="c-title">
                <div class="c-title__text u-fs--l">デバイスでの傾向</div>
              </h4>
              <div class="c-graph-donuts-wrapper">
                <svg class="c-graph-donuts c-graph-donuts--device">
                  <g class="c-graph-donuts__chart" />
                  <g class="c-graph-donuts__values" />
                  <g class="c-graph-donuts__title" />
                  <g class="c-graph-donuts__labels" />
                </svg>
                <div class="c-tooltip c-tooltip--graph-donuts c-tooltip--device">
                  <ul class="c-tooltip-list">
                    <li class="c-tooltip-list__item c-tooltip-list__item--desktop is-active">-</li>
                    <li class="c-tooltip-list__item c-tooltip-list__item--mobile is-active">-</li>
                    <li class="c-tooltip-list__item c-tooltip-list__item--tablet is-active">-</li>
                    <li class="c-tooltip-list__item c-tooltip-list__item--other is-active">-</li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="p-analysis-message__content p-analysis-message__content--os">
              <h4 class="c-title">
                <div class="c-title__text u-fs--l">OSでの傾向</div>
              </h4>
              <div class="c-graph-donuts-wrapper">
                <svg class="c-graph-donuts c-graph-donuts--os">
                  <g class="c-graph-donuts__chart" />
                  <g class="c-graph-donuts__values" />
                  <g class="c-graph-donuts__title" />
                  <g class="c-graph-donuts__labels" />
                </svg>
                <div class="c-tooltip c-tooltip--graph-donuts c-tooltip--os">
                  <ul class="c-tooltip-list">
                    <li class="c-tooltip-list__item c-tooltip-list__item--android is-active">-</li>
                    <li class="c-tooltip-list__item c-tooltip-list__item--ios is-active">-</li>
                    <li class="c-tooltip-list__item c-tooltip-list__item--windows is-active">-</li>
                    <li class="c-tooltip-list__item c-tooltip-list__item--mac is-active">-</li>
                    <li class="c-tooltip-list__item c-tooltip-list__item--other is-active">-</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
    <!-- モーダル: エラーメッセージ表示 -->
    <error-modal
      :is-active=isError
      :message=errorMessage
      :on-close-click="onCloseErrorModal"
    />
  </div>
</template>

<script>
import axios from "axios";
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
dayjs.locale('ja');

export default {
  props: {
    breadcrumbData: Array,
    displayPeriod: Object,
    messageId: String,
    summaryDate: String,
    conditionInfo: Object,
  },

  data: function () {
    return {
      errorMessage: '',
      piChartDeviceModule: null,
      piChartOsModule: null,
      messageDataTableModule: null,
      summaryMessageDaily: null,
      isEmptyPiChartDevice: false,
      isEmptyPiChartOs: false,
      isEmptyDataTable: false,
      isError: false,
      isLoadingPiChartDevice: true,
      isLoadingPiChartOs: true,
      isLoadingDataTable: true,
      isInitializedDataTable: false,
      range: {
        from: this.displayPeriod && this.displayPeriod.from && dayjs(this.displayPeriod.from).isValid()
          ? dayjs(this.displayPeriod.from).toDate()
          : dayjs().add(-30, 'days').toDate(),
        to: this.displayPeriod && this.displayPeriod.to && dayjs(this.displayPeriod.to).isValid()
          ? dayjs(this.displayPeriod.to).toDate()
          : dayjs().toDate(),
      },
      tab: {
        current: 'delivery',
      },
      sort: {
        key: 'deliveryDate',
        type: 'desc'
      }
    };
  },

  computed: {
    summaryMonthDay:  function() {
      return dayjs(this.summaryMessageDaily.summary_date).isValid()
        ? dayjs(this.summaryMessageDaily.summary_date).format('MM/DD')
        : '-'
    },
    deliveryMonthDay:  function() {
      return dayjs(this.summaryMessageDaily.message.message_deliver.send_start_date).isValid()
        ? dayjs(this.summaryMessageDaily.message.message_deliver.send_start_date).format('MM/DD')
        : '-'
    },
    deliveryTime:  function() {
      return dayjs(this.summaryMessageDaily.message.message_deliver.send_start_date).isValid()
        ? dayjs(this.summaryMessageDaily.message.message_deliver.send_start_date).format('HH:mm')
        : '-'
    },
    ctr: function () {
      let ctrString = '0.00%';
      if(this.summaryMessageDaily.display_count > 0 && this.summaryMessageDaily.click_count > 0){
        let ctr = this.summaryMessageDaily.click_count * 100 / this.summaryMessageDaily.display_count;
        ctrString = ctr.toFixed(2) + '%';
      }
      return ctrString;
    },
    message: function() {
      let message = null;
      if(this.summaryMessageDaily){
        message = this.summaryMessageDaily.message;
      }
      return message;
    },
    deviceCsvUrl: function() {
      let url = '/api/analysis/summary-message/csv?' +
        'message_id=' + this.messageId + '&summary_date=' + this.summaryDate;
      return url;
    },

    calendarStartDate: function() {
      return dayjs(this.range.from).isValid()
        ? dayjs(this.range.from).format('YYYY-MM-DD')
        : dayjs().add(-30, 'days').format('YYYY-MM-DD')
    },
    calendarEndDate: function() {
      return dayjs(this.range.to).isValid()
        ? dayjs(this.range.to).format('YYYY-MM-DD')
        : dayjs().format('YYYY-MM-DD')
    },
    displayStartDate: function() {
      return dayjs(this.range.from).isValid()
        ? dayjs(this.range.from).format('YYYY/MM/DD')
        : '-'
    },
    displayEndDate: function() {
      return dayjs(this.range.to).isValid()
        ? dayjs(this.range.to).format('YYYY/MM/DD')
        : '-'
    }
  },

  mounted: function() {
    // グラフモジュールの読み込み
    import('../../funcs/components/graph/graph-donuts-delivery-device').then(module => {
      // モジュールオブジェクトをプロパティに設定
      this.piChartDeviceModule = module;
      // モジュール読み込み後に初期化処理実行
      this.updatePiChartDevice();
    });

    // グラフモジュールの読み込み
    import('../../funcs/components/graph/graph-donuts-delivery-os').then(module => {
      // モジュールオブジェクトをプロパティに設定
      this.piChartOsModule = module;
      // モジュール読み込み後に初期化処理実行
      this.updatePiChartOs();
    });

    // データテーブルモジュールの読み込み
    import('../../funcs/components/table/table-multiple-delivery-message').then(module => {
      // モジュールオブジェクトをプロパティに設定
      this.messageDataTableModule = module;
      // モジュール読み込み後に初期化処理実行
      this.updateDataset();
    });
  },

  methods: {
    formatNumber: function(value) {
      let parsedNumber = parseInt(value, 10);
      return Number.isInteger(parsedNumber) ? parsedNumber.toLocaleString() : "0";
    },
    getConditionString: function() {
      let conditionString;
      if (this.summaryMessageDaily.message.has_custom_list) {
        conditionString = 'カスタムリスト配信';
      } else if(this.message.topic_flag == 1){
        // ALL
        conditionString = '全配信';
      } else {
        conditionString = 'セグメント配信';
      }

      return conditionString;
    },
    getMessageCustomConditionString: function(messageCustomCondition) {
      let messageCustomConditionString = '';
      let operatorString = '';
      switch(messageCustomCondition.condition_operation){
      case 'lte':
        operatorString = 'になるまで';
        break;
      case 'gte':
        operatorString = 'よりも多くなったら';
        break;
      case 'eq':
        operatorString = 'のとき';
        break;
      }

      switch(messageCustomCondition.condition_key){
      case 'click':
        messageCustomConditionString = 'サイト全体で、クリック数が累計 ' + messageCustomCondition.condition_value + '回' + operatorString;
        break;
      case 'impression':
        messageCustomConditionString = 'サイト全体で、表示数が累計 ' + messageCustomCondition.condition_value + '回' + operatorString;
        break;
      case 'frequency':
        messageCustomConditionString = '１ユーザーの、訪問回数が ' + messageCustomCondition.condition_value + '回/日' + operatorString;
        break;
      }
      return messageCustomConditionString;
    },
    hasMessageCondition: function() {
      return (this.message.message_conditions && (this.message.message_conditions.length > 0));
    },
    hasTopicMessageCondition: function() {
      return (this.message.topic_message_condition);
    },
    hasMessageCustomCondition: function() {
      return (this.message.message_custom_conditions && (this.message.message_custom_conditions.length > 0));
    },
    getCondition: function() {
      let condition = null;
      if(this.message.message_conditions && (this.message.message_conditions.length > 0)){
        let messageCondition = this.message.message_conditions[0];
        if(messageCondition.condition){
          condition = messageCondition.condition;
        }
      }
      return condition;
    },
    getConditionDetails: function(condition) {
      let conditionDetails = [];
      if(condition){
        conditionDetails = condition.condition_details;
      }
      return conditionDetails;
    },
    getConditionJoinTypeString: function(condition) {
      let conditionJoinTypeString = '';
      //let condition = this.getCondition();
      if(condition){
        conditionJoinTypeString = condition.condition_join_type;
      }
      return conditionJoinTypeString;
    },
    getConditionTypeString: function(condition) {
      let conditionTypeString = '';
      //let condition = this.getCondition();
      if(condition){
        let conditionDetails = condition.condition_details;
        if(conditionDetails && (conditionDetails.length > 0)){
          let conditionKey = conditionDetails[0].condition_key;
          const type =
            this.conditionInfo.conditionKeyTypes[conditionKey];
          if (!conditionKey || !type) return 'その他の条件';
          conditionTypeString = type + '：' + this.conditionInfo.conditionKeyExplanations[conditionKey];
        }
      }
      return conditionTypeString;
    },
    getDescription: function (conditionDetail) {
      // 変換が必要なければvalueそのまま
      let description = conditionDetail.condition_value;
      if(this.conditionInfo.conditionKeyOptions[conditionDetail.condition_key]){
        let options = this.conditionInfo.conditionKeyOptions[conditionDetail.condition_key];

        if(options[conditionDetail.condition_value]){
          // 変換が必要なら変換した値
          description = options[conditionDetail.condition_value];
        }
      }
      return description;
    },
    getTopicConditionDetails: function() {
      let topicConditionDetails = [];
      if(this.message.topic_message_condition){
        let topicMessageCondition = this.message.topic_message_condition;
        if(topicMessageCondition.topic_condition){
          topicConditionDetails = topicMessageCondition.topic_condition.topic_condition_details;
        }
      }
      return topicConditionDetails;
    },

    updatePiChartDevice: function() {
      // グラフモジュールの読み込みが完了していない場合は処理終了
      if (!this.piChartDeviceModule) return;

      // ローダー表示設定
      this.isLoadingPiChartDevice = true;

      // 送信パラメーター作成
      const params = {
        message_id: this.messageId,
        summary_date: this.summaryDate,
      }

      // パイチャート用データの取得処理実行
      axios.get(`/api/analysis/summary-message-device`, {
        params
      }).then(res => {
        // レスポンスデータの内容がイレギュラーな場合は処理終了
        if (!res.data || !res.data.items) throw new Error('Invalid response data.');

        // パイチャート更新
        this.piChartDeviceModule.graph(res.data);

        // ローダー非表示設定
        setTimeout(() => {
          this.isLoadingPiChartDevice = false;
        }, 300)
      })
        .catch(_e => {
          // エラーモーダル表示
          this.isError = true;
          this.errorMessage = '配信結果データの取得に失敗しました';

          // ローダー非表示設定
          setTimeout(() => {
            this.isLoadingPiChartDevice = false;
          }, 300)
        });
    },

    updatePiChartOs: function() {
      // グラフモジュールの読み込みが完了していない場合は処理終了
      if (!this.piChartOsModule) return;

      // ローダー表示設定
      this.isLoadingPiChartOs = true;

      // 送信パラメーター作成
      const params = {
        message_id: this.messageId,
        summary_date: this.summaryDate,
      }

      // パイチャート用データの取得処理実行
      axios.get(`/api/analysis/summary-message-os`, {
        params
      }).then(res => {
        // レスポンスデータの内容がイレギュラーな場合は処理終了
        if (!res.data || !res.data.items) throw new Error('Invalid response data.');

        // パイチャート更新
        this.piChartOsModule.graph(res.data);

        // ローダー非表示設定
        setTimeout(() => {
          this.isLoadingPiChartOs = false;
        }, 300)
      })
        .catch(_e => {
          // エラーモーダル表示
          this.isError = true;
          this.errorMessage = '配信結果データの取得に失敗しました';

          // ローダー非表示設定
          setTimeout(() => {
            this.isLoadingPiChartOs = false;
          }, 300)
        });
    },

    updateDataset: function() {
      // グラフモジュールの読み込みが完了していない場合は処理終了
      if (!this.messageDataTableModule) return;

      // ローダー表示設定
      this.isLoadingDataTable = true;

      // 送信パラメーター作成
      const params = {
        message_id: this.messageId,
        summary_date: this.summaryDate,
      }

      // データテーブル用データの取得処理実行
      axios.get(`/api/analysis/summary-message`, {
        params
      }).then(res => {
        // レスポンスデータの内容がイレギュラーな場合は処理終了
        if (!res.data || !res.data.item) throw new Error('Invalid response data.');

        this.summaryMessageDaily = res.data.item;

        // ローダー非表示設定
        setTimeout(() => {
          this.isLoadingDataTable = false;
        }, 300)
      })
        .catch(_e => {
          // エラーモーダル表示
          this.isError = true;
          this.errorMessage = '配信結果データの取得に失敗しました';

          // ローダー非表示設定
          setTimeout(() => {
            this.isLoadingDataTable = false;
          }, 300)
        });
    },

    onTabClick: function(selected) {
      // 選択値が設定されていない場合は処理終了
      if (!selected) return;

      // 選択値が現在の選択値値と同じ場合は処理終了
      if (selected == this.tab.current) return

      // 選択値を現在のタブ名に設定
      this.tab.current = selected;

      // データ更新
      this.updatePiChartDevice();
      this.updatePiChartOs();
      this.updateDataset();
    },

    onSortClick: function(e, key) {
      // ローダー表示設定
      this.isLoadingDataTable = true;

      // クリックしたソートボタンの状態で昇順・皇潤を判定 && ソートボタンの表示を切り替え
      if (e.target.classList.contains('c-btn--sort-desc')) {
        this.sort.key = key;
        this.sort.type = 'asc';
        e.target.classList.remove('c-btn--sort-asc');
        e.target.classList.remove('c-btn--sort-desc');
        e.target.classList.add('c-btn--sort-asc');
      } else {
        this.sort.key = key;
        this.sort.type = 'desc';
        e.target.classList.remove('c-btn--sort-asc');
        e.target.classList.remove('c-btn--sort-desc');
        e.target.classList.add('c-btn--sort-desc');
      }

      this.messageDataTableModule.dataList({
        key: this.sort.key,
        order: this.sort.type,
      });

      // ローダー非表示設定
      setTimeout(() => {
        this.isLoadingDataTable = false;
      }, 300)
    },

    onDateRangeChanged: function(range){
      // 取得データ期間の更新
      this.range.from = range.start;
      this.range.to= range.end;

      // データ更新
      this.updatePiChartDevice();
      this.updatePiChartOs();
      this.updateDataset();
    },

    // -----------------------------------------------------------------------------------------------------
    // エミット系メソッド一覧: 子孫のUI操作にフックエミットコールされるか、引き渡した関数オブジェクトからコールされるメソッド
    // -----------------------------------------------------------------------------------------------------
    // クリック: エラーモーダルを閉じる処理
    onCloseErrorModal: function() {
      this.isError = false
      this.errorMessage = ''
    },
  }
}
</script>

<style lang="scss" scoped>
.p-analysis-message__content.p-analysis-message__content--table-static {
    overflow: hidden;
    width: 100%;
}

#table-wrapper {
    border-bottom: solid 1px #ccc;
    box-shadow: inset 0 0 0 1px #ccc;
    margin-top: 20px;
    overflow-x: auto;
    width: 100%;
}

.c-table.c-table--static.c-table--delivery-message {
    border: none;
    border-collapse: separate;
    border-spacing: 0px;
    margin-top: 0;
    width: 1480px;
}

.sticky {
    position: sticky;
}

.c-table.c-table--static.c-table--delivery-message th,
.c-table.c-table--static.c-table--delivery-message td {
    border-left: none;
    border-top: none;
    border-bottom: none;
}

.c-table.c-table--static.c-table--delivery-message th:first-child,
.c-table.c-table--static.c-table--delivery-message td:first-child {
    left: 1px;
}

.c-table.c-table--static.c-table--delivery-message th:nth-child(2),
.c-table.c-table--static.c-table--delivery-message td:nth-child(2) {
    left: 101px;
}

.c-table.c-table--static.c-table--delivery-message th:nth-child(3),
.c-table.c-table--static.c-table--delivery-message td:nth-child(3) {
    left: 201px;
}

.c-table.c-table--static.c-table--delivery-message th:nth-child(4),
.c-table.c-table--static.c-table--delivery-message td:nth-child(4) {
    left: 301px;
}

</style>
